export const VEHICLE_TYPE_PASSENGER_CAR = 10;